import configDefault from "./config-default";

const config = {
  ...configDefault,
  analytics: {
		gtm: 'GTM-TXVXGBBS'
	},
  code: "solliesgym.fr",
  // Pas encore de favicon dédié : PNG transparent 1x1 pour éviter de retomber
  // sur le favicon OnAir mis en cache par le navigateur. À remplacer par
  // "/solliesgym-favicon.png" une fois l'asset ajouté dans public/.
  favicon:
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+M8AAAMBAQDJ/pLvAAAAAElFTkSuQmCC",
  companyName: "Sollies Gym",
  confirmation: {
    welcomeLabel: "Bienvenue chez",
    text: "Votre adhésion a bien été prise en compte, vous pourrez retirer votre badge à l'accueil",
    backLabel: "Retour au site."
  },
  website: "https://solliesgym.fr/",
  notifyChannel: "vel-solliesgym",
  header: {
    ...configDefault.header,
    title: "Je m'abonne",
    logo: "/solliesgym-header-logo.png",
  },
  htmlCustomCSS: 'solliesgym.scss',
  footer: {
    ...configDefault.footer,
    logo: null,
    cgv: {
      link: "https://solliesgym.fr/conditions-generales-de-vente-sollies-gym/",
      text: "CGV",
    },
  },
  payByCard: "PAYLINE",
  plans: {
    ...configDefault.plans,
    beforeUser: false
  },
  steps: {
    ...configDefault.steps,
    useSinglePageForm: true
  }
};

export default config;
